import { ensureContrast, getFillAndStroke } from '@ardoq/color-helpers';
import type { GetCssClassNamesOption } from '@ardoq/data-model';

/**
 * Resolves a conditional formatting filter color to fill/stroke SVG attributes.
 *
 * Shared by both component and reference display color resolution.
 *
 * Note: NEW_CONDITIONAL_FORMATTING version is 1, ORIGINAL is 0, undefined is old rules.
 */
export const resolveFilterColor = (
  filterColor: string,
  filterVersion: number | undefined,
  options: GetCssClassNamesOption
): { fill?: string; stroke?: string } => {
  const { useAsBackgroundStyle, isNewConditionalFormatting } = options;

  // Only lighten fill if:
  // - useAsBackgroundStyle is true
  // - AND (not new conditional formatting feature OR version is old/undefined)
  const isLightenedFill =
    useAsBackgroundStyle &&
    (!isNewConditionalFormatting ||
      filterVersion === undefined ||
      filterVersion === 0);

  const { fill, stroke: filterStroke } = getFillAndStroke(
    filterColor,
    isLightenedFill
  );

  // Ensure stroke has contrast with fill when using conditional formatting colors
  const stroke =
    isNewConditionalFormatting && fill && filterStroke
      ? ensureContrast(fill, filterStroke)
      : filterStroke;

  return { fill, stroke };
};
